import React from "react"
import BootcampImage3 from "../../../assets/images/bootcamp/bootcamp3.png"
import ProductImage4 from "../../../assets/images/bbhc/image 54.png"
import { Button } from "../../../components/ui/button"
import { useNavigate } from "react-router-dom"

interface Props {
  pathname: string
  jotformRef?: React.RefObject<HTMLDivElement>
  isBootcamp?: boolean
}

const PriceBlock: React.FC<Props> = ({ pathname, jotformRef, isBootcamp }) => {
  const navigate = useNavigate()

  const handleBBHCCreateAccount = () => {
    navigate("/iin-registration", { state: { from: pathname } })
  }

  const handleBootcampRegistration = () => {
    navigate("/5daybusinessbootcamp/registration")
  }

  const scrollToJotform = () => {
    if (jotformRef?.current) {
      jotformRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }
  return (
    <div className="flex flex-row gap-10 lg:flex-row items-center lg:justify-between w-full relative md:py-[96px] py-[52px] md:pr-[144px] pr-4 sm:pr-8 max-w-screen-xl mx-auto">
      <div className="hidden md:block border-l-[48px] border-l-[#37d3a1]">
        {isBootcamp ? (
          <img
            src={BootcampImage3}
            alt="Woman looking at laptop screen and thinking"
            className="w-full h-full object-cover"
          />
        ) : (
          <img
            src={ProductImage4}
            alt="Woman looking at laptop screen and thinking"
            className="w-full h-full object-cover"
          />
        )}
      </div>

      {/* Right Section - Content */}
      <div className="border-l-[48px] border-l-[#37d3a1] md:border-l-0 flex flex-col lg:ml-0 justify-center gap-8 lg:w-1/2 w-full h-auto">
        {/* Title and Price */}
        <div className="flex flex-col gap-5">
          <h2 className="text-black text-[48px] font-bold leading-tight">
            {" "}
            {isBootcamp
              ? "Program Investment"
              : "Gain exclusive access to the Business Blueprint for Health Coaches for"}{" "}
          </h2>
          {isBootcamp ? (
            <>
              {" "}
              <p className="text-2xl">
                Gain exclusive access to the{" "}
                <span className="italic">
                  From Purpose to Profit: The 5-Day Business Bootcamp for
                  Coaches
                </span>{" "}
                for only{" "}
                <span
                  className="relative inline-block font-bold text-[#4750f5] text-3xl"
                  style={{ display: "inline-block", position: "relative" }}
                >
                  <span
                    style={{
                      position: "absolute",
                      left: 0,
                      top: "50%",
                      width: "100%",
                      height: "5px",
                      backgroundColor: "red",
                      transform: "rotate(-20deg) translateY(-50%)",
                      transformOrigin: "center",
                    }}
                  ></span>
                  $695
                </span>{" "}
                <span className="font-bold text-[#4750f5] text-3xl">$556</span>{" "}
                (value $1500).
              </p>
              <p className="text-2xl">
                <span className="font-bold ">Program Dates: </span>
                {/* November 3–7, 2025 (live virtual, 90 minutes/day) */}{" "}
                January 13–18, 2026
              </p>
            </>
          ) : (
            <p className="md:text-[32px] text-[24px]">
              {/* <span className="text-[#4750f5] font-bold">ONLY $695</span>{" "} */}
              <span className="text-[#4750f5] font-bold">ONLY $556</span>{" "}
              <span className="font-medium">
                {isBootcamp ? "(value $1,500)" : "(value $1,200)"}
              </span>
            </p>
          )}
        </div>

        {/* Button */}
        <div className="w-full flex justify-start">
          {isBootcamp ? (
            <>
              <Button
                variant="default"
                onClick={handleBootcampRegistration}
                // onClick={() =>
                //   window.open(
                //     "https://form.jotform.com/253005569459161",
                //     "_blank"
                //   )
                // }
                className="px-4 py-2 bg-[#4750F5] text-white items-center gap-2 rounded-lg"
              >
                {/* <span>{"\u{1F449}"}</span> JOIN THE BOOTCAMP */}
                {/* <span>{"\u{1F449}"}</span> JOIN WAITLIST */}
                <span>{"\u{1F449}"}</span> SAVE YOUR SEAT
              </Button>
            </>
          ) : (
            <>
              {/* Register Button */}
              {/* <Button
            variant="default"
            onClick={handleBBHCCreateAccount}
            className="px-4 py-2 bg-[#4750F5] text-white items-center gap-2 rounded-lg"
          >
            REGISTER NOW
          </Button> */}
              {/* Waitlist Button */}
              <Button
                variant="default"
                onClick={scrollToJotform}
                className="px-4 py-2 bg-[#4750F5] text-white items-center gap-2 rounded-lg"
              >
                SAVE YOUR SEAT
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default PriceBlock
